import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import { saveShippingAddress } from "../Redux/Actions/cartActions";
import { POSTAL_CODES } from "../Redux/Constants/GlobalConstant";
import Select from "react-select";
import MobileNav from "../components/MobileNav";
import BestDealSection from "../components/homeComponents/BestDealSection";

const postCodeArr = POSTAL_CODES;

const ShippingScreen = ({ history }) => {
  const cart = useSelector((state) => state.cart);
  const { shippingAddress } = cart;

  const [address, setAddress] = useState(shippingAddress.address || "");
  const [city, setCity] = useState(shippingAddress.city || "");
  const [area, setArea] = useState(null);
  const [postCode, setPostCode] = useState(shippingAddress.postCode || "");

  const dispatch = useDispatch();

  useEffect(() => {
    if (shippingAddress.area) {
      const selectedArea = postCodeArr.find(
        (item) => item.value === shippingAddress.area,
      );
      setArea(selectedArea || null);
    }
    setAddress(shippingAddress.address || "");
    setCity(shippingAddress.city || "");
    setPostCode(shippingAddress.postCode || "");
  }, [shippingAddress]);

  const submitHandler = (e) => {
    e.preventDefault();

    if (!address.trim()) {
      alert("Please enter a full address");
      return;
    }
    if (!city.trim()) {
      alert("Please enter a town/city");
      return;
    }
    if (!area) {
      alert("Please select an area");
      return;
    }
    if (!postCode.trim()) {
      alert("Please enter a postcode");
      return;
    }
    if (area.value === "other") {
      alert(
        "Same Day Delivery is not available for this postcode: " +
          postCode +
          " Delivery charges will applies for this order.",
      );
    }

    dispatch(
      saveShippingAddress({
        address,
        city,
        area: area.value,
        postCode,
      }),
    );

    history.push("/payment");
  };

  return (
    <>
      <Header />
      <MobileNav />
      <div className="container d-flex justify-content-center align-items-center login-center">
        <form
          className="Login col-md-8 col-lg-4 col-11"
          onSubmit={submitHandler}
        >
          <h6>DELIVERY ADDRESS</h6>
          <input
            type="text"
            placeholder="Enter Full Address"
            value={address}
            required
            onChange={(e) => setAddress(e.target.value)}
          />
          <input
            type="text"
            placeholder="Enter Town/City"
            value={city}
            required
            onChange={(e) => setCity(e.target.value)}
          />
          <Select
            className="shipping-pincode-select"
            value={area}
            onChange={setArea}
            options={postCodeArr.filter((item) => item.deliveryEnabled)}
            required
          />
          <input
            type="text"
            placeholder="Enter PostCode"
            value={postCode}
            maxLength={7}
            minLength={3}
            required
            onChange={(e) => setPostCode(e.target.value)}
          />
          <button type="submit">Continue</button>
        </form>
      </div>
      <BestDealSection />
    </>
  );
};

export default ShippingScreen;
